import React, { FunctionComponent } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { CameraSettings } from '@paragon/contract-library';

import { SettingsDialogColumn } from '../SettingsDialogContainer';
import { SettingsControlProps } from '../types';

type Props = SettingsControlProps<CameraSettings>;

export const CameraSettingsColumn: FunctionComponent<Props> = (props) => (
  <SettingsDialogColumn title="Camera Settings">
    <FormControlLabel
      label="Flipped"
      control={
        <Checkbox
          checked={props.value.flipped}
          onChange={(event) => props.onChange({ flipped: event.target.checked })}
        />
      }
    />
    <FormControlLabel
      label="Reversed"
      control={
        <Checkbox
          checked={props.value.reversed}
          onChange={(event) => props.onChange({ reversed: event.target.checked })}
        />
      }
    />
  </SettingsDialogColumn>
);
